// extracted by mini-css-extract-plugin
export var boldText = "_2p-4";
export var checkboxContainer = "_2p-6";
export var closeIcon = "_2p-g";
export var container = "_2p-0";
export var drawer = "_2p-8";
export var drawerContent = "_2p-9";
export var extraSmallText = "_2p-5";
export var fulfillmentGroupTable = "_2p-e";
export var largeText = "_2p-3";
export var loadingSpinnerContainer = "_2p-h";
export var mediumText = "_2p-2";
export var narrow = "_2p-f";
export var notificationLink = "_2p-j";
export var packageCheckIconContainer = "_2p-7";
export var slideoutHeaderContainer = "_2p-a";
export var slideoutModal = "_2p-c";
export var stickyHeaderWrapper = "_2p-b";
export var table = "_2p-i";
export var tableContainer = "_2p-d";
export var tertiaryText = "_2p-1";